<template lang="pug">
v-card.receipt-settle-form
  v-card-title(primary-title)
    .headline.text-xs-center.red--text 請確認以下核對清單
  v-card-text
    receipt-list-info(:receipts="receipts")
  v-card-actions
    form-actions(
      :loading="formMixin_loading"
      submitText="確定審核"
      @cancel="$emit('cancel')"
      @submit="submit") {{ formMixin_message }}
  v-dialog(v-model="succeedDialog")
    v-card
      v-card-title 結算成功
      v-card-actions
        v-btn(@click="$emit('settle-succeed')") 返回
        v-btn(@click="print") 列印此次結算收據
    receipt-printer(ref="receiptPrinter"
    @printed="settleForm = false")
</template>
<script>
import { formMixin } from "@/mixins";
import { db } from "@/firebase";
import ReceiptListInfo from "@/components/ReceiptListInfo.vue";
import ReceiptPrinter from "@/components/ReceiptPrinter.vue";

export default {
  name: "ReceiptSettleForm",
  mixins: [formMixin],
  components: {
    ReceiptListInfo,
    ReceiptPrinter
  },
  props: {
    receipts: {
      type: Array,
      require: true
    }
  },
  data() {
    return {
      succeedDialog: false
    };
  },
  computed: {
    settleList() {
      return this.receipts.map(r => r.temp.id);
    }
  },
  methods: {
    async submit() {
      const res = await this.formMixin_submit(
        ["settleList"],
        "post",
        `receipt/settle`
      );
      this.succeedDialog = true;
    },
    async print() {
      const receipts = await Promise.all(
        this.settleList.map(async id => {
          return (await db
            .collection("receipts")
            .doc(id)
            .get()).data();
        })
      );
      await this.$refs.receiptPrinter.print(receipts);

      // close succeedDialog
      this.succeedDialog = false;

      // emit printed event
      this.$emit("printed");
    }
  }
};
</script>
